import client from '../client';

export const authApi = {
  login: async (credentials) => {
    const response = await client.post('/auth/login', credentials);
    return response.data;
  },

  resetPassword: async (payload) => {
    const response = await client.post('/auth/reset-password', payload);
    return response.data;
  },
};
